import React, { useState } from "react";
import { CompanyNewsTileType } from "@irati/types";
import FormattedMessage from "@irati/utils/lang";
import Icon from "@irati/ui/src/Icon";
import IconTypes from "@irati/ui/src/Icon/IconTypes.enum";
import tracking from "@irati-tracking/homepage";
import { greys } from "@irati/ui/src/global/colors";
import { Body } from "@irati/ui/src/Typography";
import NewContentModal from "../NewContent/Modal";
import { AddContent, EmptyCard } from "./styled";
var EmptyTile = function (_a) {
    var companyNewsTile = _a.companyNewsTile;
    if (companyNewsTile.config.type !== CompanyNewsTileType.Empty) {
        return null;
    }
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    // if the content is smaller than 4, it has a md size also
    var isMidSizedContent = companyNewsTile.config.columnWidth < 4;
    return (React.createElement(React.Fragment, null,
        React.createElement(EmptyCard, { color: greys.light, onClick: function () {
                tracking.homePageAddNewTileModal();
                setShowModal(true);
            }, isMisMidSizedContent: isMidSizedContent },
            React.createElement(AddContent, null,
                React.createElement("div", null,
                    React.createElement(Icon, { icon: IconTypes.plus })),
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.button" })))),
        showModal && React.createElement(NewContentModal, { companyNewsTile: companyNewsTile, onClose: function () { return setShowModal(false); } })));
};
export default EmptyTile;
